import axios from 'axios'
import { StepOneResponseDTO } from './dto/StepOneResponseDTO';
import { ValidDTO } from './dto/ValidDTO'
import { WidgetConstructorDTO } from './dto/WidgetConstructorDTO';

export class SignApi {
  /**
   * @type {string}
   */
  token;

  constructor (token) {
    this.token = token
  }

  static axios () {
    return axios.create({
      baseUrl: process.env.VUE_APP_API_URL
    })
  }

  /**
   * @param {StepOneRequestDTO} request
   */
  async stepOne (request) {
    let response = await this.constructor
      .axios()
      .post(
        process.env.VUE_APP_TSP_API_URL + '/step-one?token=' + this.token,
        request
      )
    let dataKeys = Object.keys(response.data)
    if (response.status === 200 && ['current', 'hash', 'id', 'success'].every(key => dataKeys.includes(key))) {
      response.data = new StepOneResponseDTO(response.data)
    }

    return response
  }

  /**
   * @param {StepTwoRequestDTO} request
   */
  async stepTwo (request) {
    return await this.constructor
      .axios()
      .post(
        process.env.VUE_APP_TSP_API_URL + '/step-two?token=' + this.token,
        request
      )
  }

  /**
   * @param {UpdateDTO} request
   */
  async update (request) {
    return await this.constructor
      .axios()
      .post(
        process.env.VUE_APP_TSP_API_URL + '/update?token=' + this.token,
        request
      )
  }

  async isValid () {
    let response = await this.constructor
      .axios()
      .get(process.env.VUE_APP_TSP_API_URL + '/is-valid?token=' + this.token)
    let dataKeys = Object.keys(response.data)
    if (response.status === 200 && ['success', 'isValid', 'message'].every(key => dataKeys.includes(key))) {
      response.data = new ValidDTO(response.data)
    }

    return response
  }

  async constructWidget () {
    let response = await this.constructor
      .axios()
      .get(process.env.VUE_APP_TSP_API_URL + '/construct-widget?token=' + this.token)
    let dataKeys = Object.keys(response.data)
    if (response.status === 200 && ['success', 'token', 'user', 'file', 'entity'].every(key => dataKeys.includes(key))) {
      response.data = new WidgetConstructorDTO(response.data)
    }

    return response
  }
}
